/** @module Validators */

/**
 * @type {String}
 * @private
 * @const
 */
export var ERROR = 'incorrect_format';
/**
 * Creates validator for regex
 *
 * @function regex
 * @param {string} regexStr regex string
 * @return {validator} regex validator
 */

export default function regex(regexStr) {
  return function (value) {
    if (value) {
      var reg = new RegExp(regexStr, 'gim');
      return reg.test(value) ? null : ERROR;
    }

    return null;
  };
}